import * as airlineIconGlyphs from './dist'

export type AirlineIconGlyph = keyof typeof airlineIconGlyphs

export const airlineCodesMap: Record<string, AirlineIconGlyph> = {
  'A3': 'IconAegeanAirlines',
  'SM': 'IconAirCairo',
  'MSC': 'IconAirCairo',
  'UX': 'IconAirEuropa',
  'X3': 'IconArkefly',
  'OR': 'IconArkefly',
  'BLX': 'IconArkefly',
  'RC': 'IconAtlanticAirways',
  'OS': 'IconAustrianAirlines',
  'SN': 'IconBrusselsAirlines',
  'FB': 'IconBulgariaAir',
  'BUC': 'IconBulgariaAir',
  'WX': 'IconCityjet',
  'DE': 'IconCondor',
  'CAI': 'IconCorendonAirlines',
  'CND': 'IconCorendonAirlines',
  'CXI': 'IconCorendonAirlines',
  'DX': 'IconDanishAirTransport',
  'EZY': 'IconEasyjet',
  'EJU': 'IconEasyjet',
  'U2': 'IconEasyjet',
  'WK': 'IconEdelweiss',
  'MS': 'IconEgyptair',
  'EWG': 'IconEurowings',
  'EW': 'IconEurowings',
  'FEG': 'IconFlyegypt',
  'FHY': 'IconFreebirdAirlines',
  'FH': 'IconFreebirdAirlines',
  'LH': 'IconLufthansa',
  'LG': 'IconLuxair',
  'NE': 'IconNesmaAirlines',
  'D8': 'IconNorwegian',
  'DH': 'IconNorwegian',
  'DY': 'IconNorwegian',
  'DI': 'IconNorwegian',
  'YU': 'IconNorwegian',
  '5K': 'IconNorwegian',
  '0B': 'IconNorwegian',
  'X9': 'IconNorwegian',
  'PC': 'IconPegasus',
  'AT': 'IconRoyalAirMaroc',
  'FR': 'IconRyanair',
  'RY': 'IconRyanair',
  'LW': 'IconRyanair',
  'MW': 'IconRyanair',
  'RK': 'IconRyanair',
  'RR': 'IconRyanair',
  'SK': 'IconSas',
  'SK0': 'IconSas',
  'XQ': 'IconSunExpress',
  'SDR': 'IconSundair',
  'LX': 'IconSwiss',
  'TWI': 'IconTailwindAirlines',
  'AA': 'IconTransavia',
  'TO': 'IconTransavia',
  'HV': 'IconTransavia',
  'TU': 'IconTunisair',
  'VY': 'IconVueling',
  'W6': 'IconWizzAir',
  'JTG': 'IconJetTime', //apparently this code is not used anymore (old code before company was bought)
  'JTD': 'IconJetTime',
  'GQ': 'IconSkyExpress',
  'LS': 'IconJet2',
  'LB': 'IconBulAir',
  'BT': 'IconAirBaltic',
  'QS': 'IconSmartwings',
  'V7': 'IconVolotea',
  'CAT': 'IconAirSeven',
  'DK': 'IconSunclass',
}
